"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var retell_client_js_sdk_1 = require("retell-client-js-sdk");
require("../../../../src/app.css");
var config_1 = __importDefault(require("../../../constants/config"));
var styles_1 = require("../../styles");
var retellWebClient = new retell_client_js_sdk_1.RetellWebClient();
function ModalWindow(props) {
    var _this = this;
    var _a = (0, react_1.useState)(null), micStream = _a[0], setMicStream = _a[1];
    var _b = (0, react_1.useState)(null), audioMotion = _b[0], setAudioMotion = _b[1];
    var _c = (0, react_1.useState)(false), isCalling = _c[0], setIsCalling = _c[1];
    var _d = (0, react_1.useState)(false), isTransferActive = _d[0], setTransferActive = _d[1];
    var _e = (0, react_1.useState)(false), startingCall = _e[0], setStartingCall = _e[1];
    var _f = (0, react_1.useState)([]), chatData = _f[0], setChatData = _f[1];
    var _g = (0, react_1.useState)(config_1.default.agentName), currentAgentName = _g[0], setCurrentAgentName = _g[1];
    var _h = (0, react_1.useState)(config_1.default.agentId), currentAgentId = _h[0], setCurrentAgentId = _h[1];
    var _j = (0, react_1.useState)(false), hasStartedInitialCall = _j[0], setHasStartedInitialCall = _j[1];
    var agentLastQuestion = (0, react_1.useRef)("");
    var chatContainerRef = (0, react_1.useRef)(null);
    var _k = (0, react_1.useState)(null), micAccess = _k[0], setMicAccess = _k[1];
    var transferTriggeredRef = (0, react_1.useRef)(false);
    var holdMusicRef = (0, react_1.useRef)(null);
    var userData = (0, react_1.useRef)({
        first_name: "",
        last_name: "",
        phone_number: "",
        customer_email: ""
    });
    var playHoldMusic = function () {
        if (!holdMusicRef.current) {
            var audio = new Audio('/Jazz.mp3');
            audio.loop = true;
            audio.volume = 0.5;
            holdMusicRef.current = audio;
        }
        holdMusicRef.current.play().catch(console.error);
    };
    var stopHoldMusic = function () {
        var _a;
        (_a = holdMusicRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        if (holdMusicRef.current)
            holdMusicRef.current.currentTime = 0;
    };
    var wait = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
    function registerCall(agentId_1) {
        return __awaiter(this, arguments, void 0, function (agentId, context) {
            var response, err_1;
            if (context === void 0) { context = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        console.log("Registering call...", config_1.default.apiKey);
                        return [4 /*yield*/, fetch("https://api.retellai.com/v2/create-web-call", {
                                method: "POST",
                                headers: {
                                    Authorization: "Bearer ".concat(config_1.default.apiKey),
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    agent_id: agentId,
                                    metadata: { sourceId: config_1.default.sourceId },
                                    retell_llm_dynamic_variables: __assign(__assign(__assign({}, context), userData.current), { sourceId: config_1.default.sourceId }),
                                }),
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw new Error("Call registration failed with status ".concat(response.status));
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_1 = _a.sent();
                        console.error("Call registration failed:", err_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var transferCall = function (newAgentId, context) { return __awaiter(_this, void 0, void 0, function () {
        var access_token, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    console.log("Initiating call transfer...");
                    return [4 /*yield*/, retellWebClient.stopCall()];
                case 1:
                    _a.sent();
                    playHoldMusic();
                    return [4 /*yield*/, registerCall(newAgentId, context)];
                case 2:
                    access_token = (_a.sent()).access_token;
                    return [4 /*yield*/, wait(1500)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, retellWebClient.startCall({
                            accessToken: access_token,
                            emitRawAudioSamples: true,
                            sampleRate: 24000,
                        })];
                case 4:
                    _a.sent();
                    stopHoldMusic();
                    setTransferActive(false);
                    setIsCalling(true);
                    setStartingCall(false);
                    // setCurrentAgentId(newAgentId);
                    // setCurrentAgentName(widgetConfig.transferAgentName);
                    // window.transferToAgent?.(widgetConfig.transferAgentName);
                    setHasStartedInitialCall(true);
                    props.setVisible(true);
                    transferTriggeredRef.current = false;
                    return [3 /*break*/, 6];
                case 5:
                    err_2 = _a.sent();
                    console.error("Transfer failed:", err_2);
                    stopHoldMusic();
                    transferTriggeredRef.current = false;
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var endCallAndReset = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, retellWebClient.stopCall()];
                case 1:
                    _a.sent();
                    setIsCalling(false);
                    setTransferActive(false);
                    // setCurrentAgentId(widgetConfig.oldAgentID);
                    // setCurrentAgentName(widgetConfig.oldAgentName);
                    setChatData([]);
                    setHasStartedInitialCall(false);
                    props.setVisible(false);
                    return [2 /*return*/];
            }
        });
    }); };
    function cleanText(text) {
        return text.toLowerCase().replace(/[“”]/g, '"').replace(/[‘’]/g, "'").replace(/…/g, "...").replace(/[^\w\s']+$/g, '').trim();
    }
    function shouldTriggerTransfer(content, triggerPhrases) {
        var last = content.split(/[.!?]/).map(cleanText).filter(Boolean).pop();
        return !!last && triggerPhrases.some(function (phrase) { return last === cleanText(phrase); });
    }
    var handleUpdate = function (update) { return __awaiter(_this, void 0, void 0, function () {
        var last, newContent, role, transferExamples, shouldTransfer, summary, nameParts;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    last = (_a = update.transcript) === null || _a === void 0 ? void 0 : _a[update.transcript.length - 1];
                    if (!last)
                        return [2 /*return*/];
                    newContent = last.content || "";
                    role = last.role;
                    transferExamples = [
                        "Please hold on for a moment",
                        "Please hold on for a moment while I transfer you",
                        "Please hold on for a moment while I transfer your call",
                        "Please hold on for a moment while I connect you",
                        "please hold on for just a moment"
                    ];
                    if (role === "agent" && newContent) {
                        agentLastQuestion.current = newContent.toLowerCase(); // store latest agent message
                    }
                    shouldTransfer = shouldTriggerTransfer(newContent, transferExamples);
                    if (!(role === "agent" && shouldTransfer && !transferTriggeredRef.current)) return [3 /*break*/, 3];
                    transferTriggeredRef.current = true;
                    summary = chatData.map(function (msg) { return "".concat(msg.role, ": ").concat(msg.content); }).join("\n");
                    return [4 /*yield*/, wait(3000)];
                case 1:
                    _c.sent();
                    (_b = window.transferToAgent) === null || _b === void 0 ? void 0 : _b.call(window, config_1.default.transferAgentName);
                    return [4 /*yield*/, transferCall(config_1.default.transferAgentId, {
                            handoff_reason: "agent_triggered_transfer",
                            conversation_summary: summary,
                        })];
                case 2:
                    _c.sent();
                    if (role === "user" && newContent) {
                        if (agentLastQuestion.current.includes("your name")) {
                            nameParts = newContent.trim().split(" ");
                            if (nameParts.length >= 2) {
                                userData.current.first_name = nameParts[0];
                                userData.current.last_name = nameParts.slice(1).join(" ");
                            }
                        }
                        if (agentLastQuestion.current.includes("your phone")) {
                            userData.current.phone_number = newContent.trim();
                        }
                        if (newContent.includes("@")) {
                            userData.current.customer_email = newContent.trim();
                        }
                        // Other Data  
                        if (agentLastQuestion.current.includes("interests you the most")) {
                            userData.current.customer_inquiry = newContent.trim();
                        }
                        if (agentLastQuestion.current.includes("preferred time")) {
                            userData.current.preferred_contact_time = newContent.trim();
                        }
                    }
                    return [2 /*return*/];
                case 3:
                    setChatData(function (prev) {
                        var last = prev[prev.length - 1];
                        if ((last === null || last === void 0 ? void 0 : last.role) === role) {
                            return __spreadArray(__spreadArray([], prev.slice(0, -1), true), [__assign(__assign({}, last), { content: newContent })], false);
                        }
                        return __spreadArray(__spreadArray([], prev, true), [{ role: role, content: newContent }], false);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        retellWebClient.on("call_started", function () { return setIsCalling(true); });
        retellWebClient.on("call_ended", function () {
            setIsCalling(false);
            props.setVisible(false);
        });
        retellWebClient.on("update", handleUpdate);
        retellWebClient.on("error", function (err) {
            console.error("Call error:", err);
            retellWebClient.stopCall();
        });
        return function () {
            retellWebClient.off("update", handleUpdate);
        };
    }, [chatData]);
    (0, react_1.useEffect)(function () {
        if (props.visible && !isTransferActive && !hasStartedInitialCall) {
            registerCall(currentAgentId).then(function (res) {
                retellWebClient.startCall({
                    accessToken: res.access_token,
                    emitRawAudioSamples: true,
                    sampleRate: 24000,
                });
                setStartingCall(true);
                setHasStartedInitialCall(true);
            });
        }
        else if (!props.visible && isTransferActive == false) {
            setChatData([]);
            endCallAndReset();
            // `if(isTransferActive == true) window.hengUpAgent?.(widgetConfig.agentName);`
            // retellWebClient.stopCall();
        }
    }, [props.visible]);
    return (react_1.default.createElement("div", { style: __assign(__assign({}, styles_1.styles.modalWindow), { display: false ? "block" : "none", opacity: false ? "1" : "0", transition: "opacity 0.3s ease" }) },
        react_1.default.createElement("div", { className: "chat-container", ref: chatContainerRef, style: {
                height: "56vh",
                width: "100%",
                overflowY: "auto",
                background: "#333",
                padding: "1rem",
                borderRadius: "10px",
                display: startingCall && !isCalling ? "flex" : "block",
                justifyContent: "center",
                alignItems: "center",
            } }, startingCall && !isCalling ? (react_1.default.createElement("div", { className: "loading-icon" },
            react_1.default.createElement("div", { className: "spinner" }),
            react_1.default.createElement("p", { style: { color: "#fff", marginTop: "1rem" } },
                "Connecting with ",
                currentAgentName,
                "..."))) : (react_1.default.createElement(react_1.default.Fragment, null,
            chatData.map(function (message, index) { return (react_1.default.createElement("div", { key: index, className: "chat-bubble ".concat(message.role === "agent" ? "agent" : "user") }, message.content)); }),
            isCalling && (react_1.default.createElement("button", { onClick: endCallAndReset, className: "end-call-button" },
                "End Call with ",
                currentAgentName)))))));
}
exports.default = ModalWindow;
// declare global {
//   interface Window {
//     transferToAgent?: (name: string) => void;
//   }
// }
